<template>
  <main class="login-container">
    <header>
      <h1 class="title">{{ $t('login.title') }}</h1>
      <h4 class="subtitle">{{ $t('login.logInToYourAccount') }}</h4>
    </header>
    <div class="login-box">
      <div class="login-option-container">
        <button
          class="google-signin-button pointer"
          @click="handleClickGoogleLogin">
          <svg-icon
            class="google-icon"
            icon-class="google-icon"/>
          <span>{{ $t('login.signInWithGoogle') }}</span>
        </button>
      </div>
    </div>
    <footer>
      <el-dropdown
        class="pointer round-hover-effect"
        trigger="click"
        @command="handleDropdownCommand">
        <span class="el-dropdown-link">
          {{ selectedAppLanguageName }}<i class="el-icon-arrow-down el-icon--right"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="language in languages"
            :key="language.name"
            :command="language.locale">
            {{ language.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </footer>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { APP_LANGUAGE_LIST } from '../../utils/const'
import { initGoogleAPI } from '../../utils/googleAuth'

export default {
  name: 'Login',
  mounted() {
    this.loading = true
    initGoogleAPI().then((googleClient)=> {
      this.googleClient = googleClient
      this.googleClient.callback = this.signInToGoogle
      this.loading = false
    })
  },
  data() {
    return {
      googleClient: null,
      languages: APP_LANGUAGE_LIST,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      selectedAppLanguageName: 'app/languageName',
    }),
  },
  methods: {
    ...mapActions({
      loginWithGoogle: 'user/loginWithGoogle',
      setAppLanguage: 'app/setLanguage',
    }),
    handleDropdownCommand(locale) {
      this.changeAppLanguage(locale)
    },
    async changeAppLanguage(locale) {
      try {
        await this.setAppLanguage(locale)
      } catch (error) {
        console.log(error)
      }
    },
    handleClickGoogleLogin() {
      if (this.googleClient) {
        this.googleClient.requestAccessToken()
      }
    },
    async signInToGoogle(tokenResponse) {
      try {
        // const googleUser = await signInToGoogle()
        this.signIn(tokenResponse.access_token)
      } catch (error) {
        this.$alert(this.$t('message.refreshAndTryAgain'), this.$t('error.errorSigningInToGoogle'), {
          type: 'error',
          confirmButtonText: this.$t('button.ok'),
        })
      }
    },
    async signIn(googleAccessToken) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('login.loggingYouIn'),
      })

      try {
        await this.loginWithGoogle(googleAccessToken)

        this.$nextTick(() => {
          this.$router.push({ path: '/' })
          loading.close()
        })
      } catch (error) {
        this.$nextTick(() => {
          loading.close()
        })
        this.$alert(`${this.$t('common.error')}: ${error}`, this.$t('error.errorSigningInToGoogle'), {
          type: 'error',
          confirmButtonText: this.$t('button.ok'),
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  @include mobile {
    background-color: $color-default;
    &:before {
      height: 48px;
      content: '';
    }
  }

  header {
    position: relative;
    text-align: center;
    color: $color-black;
    .title {
      font-size: 48px;
      color: $color-default;
      margin-bottom: 15px;
      @include mobile {
        color: white;
        margin-bottom: 30px;
      }
    }
    .subtitle {
      @include mobile {
        color: white;
        font-size: 20px;
      }
    }
  }

  .login-box {
    flex-shrink: 0;
    margin: 0 auto;
    border-radius: 5px;
    padding: 40px;
    max-width: 100%;
    background-color: white;
    @include mobile {
      min-height: 0;
      margin: 30px auto;
      width: 400px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
    .login-option-container {
      display: flex;
      justify-content: center;
    }
    .google-signin-button {
      display: flex;
      align-items: center;
      width: 240px;
      height: 35px;
      padding: 0 20px;
      border: 1px solid #000;
      color: #000;
      background-color: #fff;
      border-radius: $border-radius-base;
      .google-icon {
        width: 24px;
        height: 24px;
        margin-right: 20px;
      }
      span {
        font-size: 14px;
      }
    }
  }

  footer {
    display: flex;
    justify-content: center;
    margin: auto auto 20px auto;
    padding: 10px;
    .el-dropdown {
      padding: 5px;
      color: $color-default;
      @include mobile {
        color: white;
      }
    }
  }
}
</style>
